export const adultAgeLimit = 18
export const daysToGoWarning = 2
export enum CountdownVariant {
    PRIMARY = "Primary",
    WARNING = "Warning",
    SECONDARY = "Secondary",
}
export const welcomeMessageTemplate = `Welcome to That's The Ticket, {0}!`
export const ticketsStatusMessage = "Tickets"
export const tncTemplate = `{0} Terms & Conditions`

export const defaultInitialFillPercentageStr = "100"

export const termsandconditionsFileName = "termsandconditions.pdf"